import {useEffect, useState} from 'react'
import {QueryStatus} from 'src/types'
import {HttpTransferenciaTerceros} from "../api/httpTransferenciaTerceros";
import {CuentaTransferenciaTerceros} from "../types/types";

export const useCuentas = (idOperacion: number) => {
  const [cuentas, setCuentas] = useState<CuentaTransferenciaTerceros[]>()
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

  const fetch = () => {
    setStatus(QueryStatus.Loading)

    HttpTransferenciaTerceros.getCuentas(idOperacion)
      .then(value => {
        setCuentas(value)
        setStatus(QueryStatus.Success)
      })
      .catch(e => {
        setStatus(QueryStatus.Error)
        console.log(e)
      })
  }

  const refetch = () => fetch()

  useEffect(() => {
    fetch()
  }, [idOperacion])

  return {cuentas, refetch, status}
}
